import React,{useEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import HandShake from '@project/shared/src/img/handShake.jpg';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height:'100vh',
    backgroundColor:'#536DFE',
    backgroundImage: `url(${HandShake})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '50% 50%',
    backgroundSize:'cover',
  },
  box2:{
    background:'#12121238',
    height:'100%',
    display:"flex",
    alignItems:"center",
    color:'white'
  }
}));

export default function ThankYouPage() {
  const classes = useStyles();

  useEffect(() => {
    const gtag = window.gtag;
    gtag('event', 'conversion', {
      'send_to': 'AW-564079504/lqjECOac6uEBEJDX_IwC',
      'value': 1.0,
      'currency': 'INR',
      'transaction_id': ''
    })
  });

  return (
    <Box className={classes.root}>
      <Box className={classes.box2}>
        <Box width="100%" textAlign="center">
          <Typography variant="h2" gutterBottom>
            Thank you for contacting us!
          </Typography>
          <Typography variant="h6" gutterBottom>
            Shortly we will connect with you
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
